import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router';

/**
 * Links into a screen from elsewhere (search, quick create, an approval): `?open=<id>` opens a
 * record, `?new=<kind>` starts a new one. The screen does it once, then the parameter is taken
 * out of the address so going back or reloading does not do it again. It works when the screen
 * is already open, too.
 */
export function useLinkParam(name: string, run: (value: string) => void) {
  const [params, setParams] = useSearchParams();
  const value = params.get(name);
  const latest = useRef(run);
  latest.current = run;
  useEffect(() => {
    if (!value) return;
    latest.current(value);
    setParams(
      (p) => {
        const next = new URLSearchParams(p);
        next.delete(name);
        return next;
      },
      { replace: true },
    );
  }, [value, name, setParams]);
}
